export default {
  totalCharacters: 200,
  listTimeDuration: [
    { id: 1, name: "1 min" },
    { id: 5, name: "5 min" },
    { id: 10, name: "10 min" },
    { id: 15, name: "15 min" },
    { id: "free", name: "Free Time" },
  ],
  selectedTimeDuration: "free",

  // until some DRY solution comes up
  lessons: [
    { title: "Lesson 1", name: "f j" },
    { title: "Lesson 2", name: "d k" },
    { title: "Lesson 3", name: "f j d k" },
    { title: "Lesson 4", name: "s l" },
    { title: "Lesson 5", name: "a ;" },
    { title: "Lesson 6", name: "s l a ;" },
    { title: "Lesson 7", name: "g h '" },
    { title: "Lesson 8", name: "f j d k s l a ; g h '" },

    { title: "Lesson 9", name: "F J" },
    { title: "Lesson 10", name: "D K" },
    { title: "Lesson 11", name: "F J D K" },
    { title: "Lesson 12", name: "S L" },
    { title: "Lesson 13", name: "A :" },
    { title: "Lesson 14", name: "S L A :" },
    { title: "Lesson 15", name: 'G H "' },
    { title: "Lesson 16", name: 'F J D K S L A ; G H "' },

    { title: "Lesson 17", name: "r u" },
    { title: "Lesson 18", name: "e i" },
    { title: "Lesson 19", name: "r u e i" },
    { title: "Lesson 20", name: "w o" },
    { title: "Lesson 21", name: "q p" },
    { title: "Lesson 22", name: "w o q p" },
    { title: "Lesson 23", name: "t [" },
    { title: "Lesson 24", name: "y ]" },
    { title: "Lesson 25", name: "t [ y ]" },
    { title: "Lesson 26", name: "r u e i w o q p t [ y ]" },

    { title: "Lesson 27", name: "R U" },
    { title: "Lesson 28", name: "E I" },
    { title: "Lesson 29", name: "R U E I" },
    { title: "Lesson 30", name: "W O" },
    { title: "Lesson 31", name: "Q P" },
    { title: "Lesson 32", name: "W O Q P" },
    { title: "Lesson 33", name: "T {" },
    { title: "Lesson 34", name: "Y }" },
    { title: "Lesson 35", name: "T { Y }" },
    { title: "Lesson 36", name: "R U E I W O Q P T { Y }" },

    { title: "Lesson 37", name: "v m" },
    { title: "Lesson 38", name: "c ," },
    { title: "Lesson 39", name: "v m c ," },
    { title: "Lesson 40", name: "x ." },
    { title: "Lesson 41", name: "z /" },
    { title: "Lesson 42", name: "x . z /" },
    { title: "Lesson 43", name: "b n" },
    { title: "Lesson 44", name: "v m c , x . z / b n" },

    { title: "Lesson 45", name: "V M" },
    { title: "Lesson 46", name: "C <" },
    { title: "Lesson 47", name: "V M C <" },
    { title: "Lesson 48", name: "X >" },
    { title: "Lesson 49", name: "Z ?" },
    { title: "Lesson 50", name: "X > Z ?" },
    { title: "Lesson 51", name: "B N" },
    { title: "Lesson 52", name: "V M C < X > Z ? B N" },
  ],
  learnLessons: [
    {
      id: "R1",
      name: "बीच वाली पंक्ति",
      withoutShift: [
        { title: "Lesson 1", name: "f j" },
        { title: "Lesson 2", name: "d k" },
        { title: "Lesson 3", name: "f j d k" },
        { title: "Lesson 4", name: "s l" },
        { title: "Lesson 5", name: "a ;" },
        { title: "Lesson 6", name: "s l a ;" },
        { title: "Lesson 7", name: "g h '" },
        { title: "Lesson 8", name: "f j d k s l a ; g h '" },
      ],
      withShift: [
        { title: "Lesson 9", name: "F J" },
        { title: "Lesson 10", name: "D K" },
        { title: "Lesson 11", name: "F J D K" },
        { title: "Lesson 12", name: "S L" },
        { title: "Lesson 13", name: "A :" },
        { title: "Lesson 14", name: "S L A :" },
        { title: "Lesson 15", name: 'G H "' },
        { title: "Lesson 16", name: 'F J D K S L A ; G H "' },
      ],
    },
    {
      id: "R2",
      name: "ऊपर वाली पंक्ति",
      withoutShift: [
        { title: "Lesson 17", name: "r u" },
        { title: "Lesson 18", name: "e i" },
        { title: "Lesson 19", name: "r u e i" },
        { title: "Lesson 20", name: "w o" },
        { title: "Lesson 21", name: "q p" },
        { title: "Lesson 22", name: "w o q p" },
        { title: "Lesson 23", name: "t [" },
        { title: "Lesson 24", name: "y ]" },
        { title: "Lesson 25", name: "t [ y ]" },
        { title: "Lesson 26", name: "r u e i w o q p t [ y ]" },
      ],
      withShift: [
        { title: "Lesson 27", name: "R U" },
        { title: "Lesson 28", name: "E I" },
        { title: "Lesson 29", name: "R U E I" },
        { title: "Lesson 30", name: "W O" },
        { title: "Lesson 31", name: "Q P" },
        { title: "Lesson 32", name: "W O Q P" },
        { title: "Lesson 33", name: "T {" },
        { title: "Lesson 34", name: "Y }" },
        { title: "Lesson 35", name: "T { Y }" },
        { title: "Lesson 36", name: "R U E I W O Q P T { Y }" },
      ],
    },
    {
      id: "R3",
      name: "नीचे वाली पंक्ति",
      withoutShift: [
        { title: "Lesson 37", name: "v m" },
        { title: "Lesson 38", name: "c ," },
        { title: "Lesson 39", name: "v m c ," },
        { title: "Lesson 40", name: "x ." },
        { title: "Lesson 41", name: "z /" },
        { title: "Lesson 42", name: "x . z /" },
        { title: "Lesson 43", name: "b n" },
        { title: "Lesson 44", name: "v m c , x . z / b n" },
      ],
      withShift: [
        { title: "Lesson 45", name: "V M" },
        { title: "Lesson 46", name: "C <" },
        { title: "Lesson 47", name: "V M C <" },
        { title: "Lesson 48", name: "X >" },
        { title: "Lesson 49", name: "Z ?" },
        { title: "Lesson 50", name: "X > Z ?" },
        { title: "Lesson 51", name: "B N" },
        { title: "Lesson 52", name: "V M C < X > Z ? B N" },
      ],
    },
  ],
};
